module.exports = require("react-addons-update");


/*****************
 ** WEBPACK FOOTER
 ** external "react-addons-update"
 ** module id = 187
 ** module chunks = 0
 **/